import { useState } from "react";
import { supabase } from "../../supabaseClient";
import { logAnalyticsEvent } from "../engagement/Amplitude";

const LogInModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogIn = async () => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });
    try {
      if (error) {
        console.error(error);
        return;
      }
      console.log(data);
      logAnalyticsEvent("Log In");
      onClose();
    } catch (e) {
      logAnalyticsEvent("Log In Error", {
        error: e,
      });
      console.error(e);
    }
  };

  return (
    <div className={`modal ${isOpen ? "modal-open" : ""}`}>
      <div className="modal-box">
        <h3 className="font-bold text-lg">Login</h3>
        <div className="form-control">
          <label className="label">
            <span className="label-text">Email</span>
          </label>
          <input
            type="email"
            placeholder="Enter your email"
            className="input input-bordered"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="form-control">
          <label className="label">
            <span className="label-text">Password</span>
          </label>
          <input
            type="password"
            placeholder="Enter your password"
            className="input input-bordered"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="modal-action">
          <button
            className="btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleLogIn}
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogInModal;
